export const ACEFlags = {
  flag_request_constent_sms_template_id: 'request-constent-sms-template-id',
  flag_disable_tree_view_buttons: 'ace-gradual-vertical-meny-cleaning',
  flag_bucket_assignment_system: 'bucket-assignment-system',
  flag_allow_add_co_applicant: 'allow-add-co-applicant',
  flag_change_address_type: 'change-address-type',
};
